import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import {AuthService} from '../../../applications/securite/service/auth.service';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {


  public iconSidebar;
  public menuItems: Menu[];

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone = true;
  public rightArrowNone = false;
   // items :BehaviorSubject<Menu[]>;
   items :any;

  constructor(private router: Router, public navServices: NavService,
              public layout:LayoutService, public authservice: AuthService) {
    // this.items = this.navServices.itemsCandidat; // ou une valeur par défaut

    console.log("authservice.loggedUser",authservice.loggedUser);

    if (authservice.loggedUser && authservice.loggedUser.role) {
      const niveau = authservice.loggedUser.role.niveau;

      if (niveau === 1) {
        console.log("role 1");
        this.items = this.navServices.itemsCandidat; // ou une valeur par défaut

      } else if (niveau === 2) {
        console.log("role 2");
        this.items = this.navServices.itemsStructure;

      } else if (niveau >= 3) {
        console.log("role supérieur ou égal à 3");
        this.items = this.navServices.itemsAdmin;

      }
    } else {
      console.log("pas de role");

      // Initialiser items avec une valeur par défaut, si nécessaire
      this.items = new BehaviorSubject<Menu[]>([]); // Valeur par défaut
    }
console.log("this.items: ",this.items);

      this.items.subscribe(menuItems => {
        this.menuItems = menuItems;

        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            menuItems.forEach(item => {
              if (item.path === event.url) {
                this.setNavActive(item);
              }
              if (item.children) {
                item.children.forEach(subItem => {
                  if (subItem.path === event.url) {
                    this.setNavActive(subItem);
                  }
                  if (subItem.children) {
                    subItem.children.forEach(subSubItem => {
                      if (subSubItem.path === event.url) {
                        this.setNavActive(subSubItem);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      });



    // this.items.subscribe(menuItems => {
    //   this.menuItems = menuItems;
    //   this.router.events.subscribe((event) => {
    //     if (event instanceof NavigationEnd) {
    //       menuItems.filter(items => {
    //         if (items.path === event.url) {
    //           this.setNavActive(items);
    //         }
    //         if (!items.children) { return false; }
    //         items.children.filter(subItems => {
    //           if (subItems.path === event.url) {
    //             this.setNavActive(subItems);
    //           }
    //           if (!subItems.children) { return false; }
    //           subItems.children.filter(subSubItems => {
    //             if (subSubItems.path === event.url) {
    //               this.setNavActive(subSubItems);
    //             }
    //           });
    //         });
    //       });
    //     }
    //   });
    // });

  }

  @HostListener('window:resize', ['$event'])
  // tslint:disable-next-line:typedef
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  // tslint:disable-next-line:typedef
  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  // tslint:disable-next-line:typedef
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  // For Horizontal Menu
  // tslint:disable-next-line:typedef
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  // tslint:disable-next-line:typedef
  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }
}
